/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootState';
import ComponentLineChart from './ComponentLineChart';
import { Vessel } from '../types';

function LineChartSection() {
  const { reportPdfResponse4 } = useSelector((state:RootState) => state.reportPdfSliceReducer);
  const phaseCharts = reportPdfResponse4?.Phase_Charts || [];
  const phaseChartLength = phaseCharts.length;
  const rearrange = (vsl: Vessel[]) => {
    if (vsl?.length > 0 && vsl[0]?.IsMultiOffset) {
      const sortedData = [...vsl].sort((a, b) => Number(a.Section) - Number(b.Section));
      return sortedData;
    }
    return vsl;
  };
  return (
    <>
      {
        phaseCharts.map((item, indexVal) => (
          <div>
            {
              rearrange(item)?.map((details, index) => (
                <div key={details.Id}>
                  {index > 0 && <div className="page-break" />}
                  <ComponentLineChart newDetails={details} />
                </div>
              ))
            }
            {indexVal !== phaseChartLength - 1 && <div className="page-break" />}
          </div>
        ))
      }
    </>
  );
}

export default LineChartSection;
